import { Component, Input, OnInit } from '@angular/core';
import { GermplasmMergeRequest } from '../../shared/germplasm/model/germplasm-merge-request.model';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GermplasmService } from '../../shared/germplasm/service/germplasm.service';
import { AlertService } from '../../shared/alert/alert.service';
import { JhiEventManager } from '../../shared/core-utils';
import { GermplasmMergeSummary } from '../../shared/germplasm/model/germplasm-merge-summary.model';

@Component({
    selector: 'jhi-merge-germplasm-review',
    templateUrl: './merge-germplasm-review.component.html',
})
export class MergeGermplasmReviewComponent implements OnInit {
    @Input()
        germplasmMergeRequest: GermplasmMergeRequest;

    isLoading: boolean;
    germplasmMergeSummary: GermplasmMergeSummary;

    constructor(
        private germplasmService: GermplasmService,
        private alertService: AlertService,
        private modal: NgbActiveModal,
        private eventManager: JhiEventManager) {
    }

    ngOnInit(): void {
        this.isLoading = true;
        this.germplasmService.reviewGermplasmMerge(this.germplasmMergeRequest).toPromise().then((summary: any) => {
            this.germplasmMergeSummary = summary;
        }).finally(() => this.isLoading = false);
    }

    dismiss() {
        this.modal.dismiss();
    }

    confirm() {
        this.isLoading = true;
        this.germplasmService.mergeGermplasm(this.germplasmMergeRequest).toPromise()
            .then(() => {
                this.alertService.success('merge-germplasm.success');
                this.modal.dismiss();
                // Refresh the Germplasm Manager search germplasm table to reflect the changes made in germplasm.
                this.eventManager.broadcast({ name: 'germplasmDetailsChanged' });
            });
    }
}
